"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.align = exports.pattern = void 0;

var pattern = function pattern(theme) {
  return {
    lavender: {
      id: 'lavender-pattern',
      type: 'patternDots',
      size: 7,
      padding: 4,
      stagger: false,
      color: theme.color.lavender,
      background: "".concat(theme.color.lavender, "E2")
    },
    petunia: {
      id: 'petunia-pattern',
      type: 'patternLines',
      gap: 20,
      rotation: 45,
      lineWidth: 8,
      color: theme.color.petunia,
      background: "".concat(theme.color.petunia, "E2")
    },
    larkspur: {
      id: 'larkspur-pattern',
      type: 'patternDots',
      size: 9,
      padding: 4,
      stagger: true,
      color: theme.color.larkspur,
      background: "".concat(theme.color.larkspur, "E2")
    },
    poppy: {
      id: 'poppy-pattern',
      type: 'patternLines',
      gap: 20,
      rotation: 0,
      lineWidth: 9,
      color: theme.color.poppy,
      background: "".concat(theme.color.poppy, "B2")
    },
    navy: {
      id: 'navy-pattern',
      type: 'patternLines',
      gap: 17,
      rotation: 90,
      lineWidth: 6,
      color: theme.color.navy,
      background: "".concat(theme.color.navy, "E2")
    },
    daffodil: {
      id: 'daffodil-pattern',
      type: 'patternSquares',
      size: 8,
      padding: 3,
      stagger: true,
      color: theme.color.daffodil,
      background: "".concat(theme.color.daffodil, "E2")
    }
  };
};

exports.pattern = pattern;
var align = {
  left: 'left',
  right: 'right'
};
exports.align = align;